import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import DMSDeviceTableComponent from "./dms-device-table.component";
import TableSort from "../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../shared/helpers/upper-case";
import { useQuery } from "@tanstack/react-query";
import { getDMSDevices } from "../../../../../core/api/services/dms.device.service";

const DMSDeviceComponent = () => {
  const [PageNumber, setPageNumber] = useState<number>(1);
  const [filters, setFilters] = useState<any>({});
  const [dmsDeviceSearchValue, setDmsDeviceSearchValue] = useState("");
  // const [dmsDeviceSearchValue, setDmsDeviceSearchValue] = useState<any>(undefined);
  const pageSize = 10;

  const filter = useSelector((state: any) => {
    return state.dmsDevice.filter;
  });

  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("deviceCode"));
  const [SortDirection, setSortDirection] = useState<any>("desc");

  const [columns, setColumns] = useState([
    {
      title: "Device ID",
      label: "deviceCode",
      isSorted: true,
      // width: "25rem",
      type: "link",
      link: "/admin/dms/device",
      linkableField: "deviceId",
    },
    {
      title: "Device Display Name",
      label: "deviceDisplayName",
      type: "text",
      // width: "16rem",
    },
    {
      title: "Status",
      label: "deviceOnlineStatus",
      // width: "13rem",
    },
    {
      title: "Last Seen",
      label: "lastDataRecievedtimestamp",
      type: "datetime",
      // width: "18rem",
    },
    {
      title: "Address",
      label: "address",
      // width: "18rem",
    },
    {
      title: "Registration Date",
      label: "registrationTimeStamp",
      type: "datetime",
      // width: "18rem",
    },
    /*     {
      title: "First Seen",
      label: "firstActiveTimeStamp",
      type: "datetime",
      width: "18rem",
    }, */
    /*     {
      title: "Device Online Status",
      label: "deviceOnlineStatus",
      type: "text",
      width: "13rem",
    }, */
    {
      title: "Firmware Version",
      label: "firmwareVersion",
      type: "text",
      // width: "13rem",
    },
  ]);

  const {
    data: dmsDevices,
    isLoading: isLoadingDmsDevices,
    refetch,
  } = useQuery({
    queryKey: [
      "getDMSDevices",
      PageNumber,
      filters?.townCouncil,
      filters?.site,
      filters?.block,
      filters?.isActive,
      filters?.insOnline,
      SortBy,
      SortDirection,
      dmsDeviceSearchValue,
    ],
    queryFn: ({ signal }) =>
      getDMSDevices(
        PageNumber,
        pageSize,
        filters?.townCouncil,
        filters?.site,
        filters?.block,
        filters?.isActive,
        filters?.isOnline,
        SortBy,
        SortDirection,
        dmsDeviceSearchValue,
        signal,
      ),
  });

  const onRefetchData = () => {
    if (dmsDevices?.numberOfRecords <= pageSize + 1) {
      setPageNumber(1);
    }
    void refetch();
  };

  useEffect(() => {
    setPageNumber(1);
    setFilters(filter);
  }, [filter]);

  useEffect(() => {
    onRefetchData();
  }, [filters]);

  const handleChangePage = useCallback((page: number): void => {
    setPageNumber(page);
  }, []);

  const handleSearch = useCallback((searchVal: string): void => {
    setPageNumber(1);
    setDmsDeviceSearchValue(searchVal);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    [],
  );

  return (
    <div>
      <DMSDeviceTableComponent
        columns={columns}
        data={dmsDevices?.data}
        totalNumberOfRecords={dmsDevices?.numberOfRecords}
        pageSize={pageSize}
        current={PageNumber}
        onChangePage={handleChangePage}
        onRefetchData={onRefetchData}
        onChangeSort={handleChangeSort}
        isLoading={isLoadingDmsDevices}
        onSearch={handleSearch}
        filter={filter}
        dmsDeviceSearchValue={dmsDeviceSearchValue}
        sortBy={SortBy}
        sortDirection={SortDirection}
      />
    </div>
  );
};

export default DMSDeviceComponent;
